module.exports = __webpack_public_path__ + "static/media/in.230b82c4.svg";